export const isEmptyObject = (obj: object = {}): boolean => Object.keys(obj).length === 0 && obj.constructor === Object;
